import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import { IMenubarList } from "/@/type/store/layout";
import { components } from "/@/router/asyncRouter";
import { i18n } from "/@/i18n";

const Components: IObject<() => Promise<typeof import("*.vue")>> =
  Object.assign({}, components, {
    Layout: (() => import("/@/layout/index.vue")) as unknown as () => Promise<
      typeof import("*.vue")
    >,
    Redirect: (() =>
      import("/@/layout/redirect.vue")) as unknown as () => Promise<
      typeof import("*.vue")
    >,
  });

// 静态路由页面
export const allowRouter: Array<IMenubarList> = [
  {
    name: "chat",
    path: "/",
    component: Components["Layout"],
    redirect: "/chat/List",
    meta: {
      title: "router.menu.chat",
      icon: "icon-shemeizhanghaoliaotianoff",
      activeIcon: "icon-shemeizhanghaoliaotianoff",
    },
    children: [
      {
        name: "List",
        path: "/chat/List",
        component: Components["List"],
        meta: {
          title: "router.menu.chat",
          icon: "icon-shemeizhanghaoliaotianoff",
          activeIcon: "icon-shemeizhanghaoliaotianoff",
        },
      },
    ],
  },
  {
    name: "Seat",
    path: "/Seat",
    component: Components["Layout"],
    redirect: "/Seat/sList",
    meta: {
      title: "router.menu.seat",
      icon: "icon-zuoxikefuoff",
      activeIcon: "icon-zuoxikefuoff",
    },
    children: [
      {
        name: "sList",
        path: "/Seat/sList",
        component: Components["sList"],
        meta: {
          title: "router.menu.seat",
          icon: "icon-zuoxikefuoff",
          activeIcon: "icon-zuoxikefuoff",
        },
      },
    ],
  },
  {
    name: "Login",
    path: "/Login",
    component: Components.Login,
    meta: { title: "登录", hidden: true },
  },
  {
    name: "Protocol",
    path: "/Protocol",
    component: Components["Protocol"],
    meta: { title: "隐私协议", hidden: true },
  },
];
const router = createRouter({
  history: createWebHashHistory(), // createWebHistory
  routes: allowRouter as RouteRecordRaw[],
});
// 在每次路由变化之前更新页面标题
router.afterEach((to, from, next) => {
  const titleKey = to.meta.title; // 获取 meta 中的标题 key
  console.log(titleKey);
  if (titleKey) {
    const title = i18n.global.t(`${titleKey}`); // 根据当前语言获取标题
    document.title = title || "Default Title"; // 设置页面标题
  }
});

export default router;
